import { Card, CardContent, CardHeader, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import MobileStoreButton from "react-mobile-store-button/lib/MobileStoreButton";

export default function MobileAppsLinkCard () {
    const { t } = useTranslation()
    return (
        <Card sx={{ p: 2 }}>
            <CardHeader title={t("FreelnaceDriverAppsHint")} />
            <Divider />
            <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <MobileStoreButton
                    store="ios"
                    url={"https://apps.apple.com/ba/app/mapit-driver/id1587487704"}
                    linkProps={{ title: 'App Store Button' }}
                    height={44}
                    width={150}
                />
                <MobileStoreButton
                    store="android"
                    url={"https://play.google.com/store/apps/details?id=com.mapit.mapitdriver"}
                    linkProps={{ title: 'Play Store Button' }}
                    height={66}
                    width={170}
                />
            </CardContent>
        </Card>
    )
}